import React, { useEffect } from "react"

import styled from "styled-components"

import { useLocalization } from "@izettle/lingo-client"
import { IllustrationIdentityCardSvg, spacing } from "@izettle/otto"
import { Text, Illustration } from "@izettle/react"

import { Cancel } from "@/components/cancel"
import { PageWrapper } from "@/components/layout-helpers"
import { useSetPageTitle } from "@/components/page-title"
import { baseUrl } from "@/constants"
import { SelectFilesProps } from "@/models"

import { DocumentItem } from "./document-item"
import { documentsByMarket } from "./documents"
import { DocumentProps } from "./types"

const ImageContainer = styled.div`
  height: 200px;
  max-width: 279px;
  margin: ${spacing.large} ${spacing.none} ${spacing.medium};
`;

const PageTitle = styled(Text.Title2)`
  margin: ${spacing.none} ${spacing.none} ${spacing.tiny} ${spacing.none};
`

const DocumentTypeTitle = styled(Text.RegularBold)`
  margin-top: ${spacing.xxSmall};
  margin-bottom: ${spacing.xxSmall};
`

type OverviewProps = {
  selectFiles: SelectFilesProps
}

export const Overview: React.FC<OverviewProps> = ({ selectFiles }) => {
  const { text, translator } = useLocalization()
  const { setPageTitle } = useSetPageTitle()

  const documents: DocumentProps[] | undefined = documentsByMarket.get(translator.locale)

  useEffect(() => {
    setPageTitle(text("PROOF_OF_IDENTITY"))
  }, [])

  return (
    <PageWrapper>
      <Cancel url={baseUrl} />
      <ImageContainer>
        <Illustration illustration={IllustrationIdentityCardSvg} alt="" width="100%" height="200px" aria-hidden  />
      </ImageContainer>
      <PageTitle>{text("PROOF_OF_IDENTITY")}</PageTitle>
      <Text.Regular>{text("PROOF_OF_IDENTITY_SUBTITLE")}</Text.Regular>
      <DocumentTypeTitle>
        {text("PROOF_OF_IDENTITY_DOCUMENT_TYPE_TITLE")}
      </DocumentTypeTitle>
      {documents?.map((document, index) => (
        <DocumentItem
          key={document.type}
          selectFiles={selectFiles}
          isRecommended={index === 0}
          document={document}
        />
      ))}
    </PageWrapper>
  )
}
